import React, { ReactElement, useEffect, useState } from 'react';
import { ClientDto, ProjectDto, SiteDto } from '../../api/ClientApi';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { Box, Grid2, Typography } from '@mui/material';
import { SiteTypeSR } from '../../common/Types';
import { getAddressFromLoactionInfo, mapsSearchUrl } from '../../common/Extensions';
import { WarehouseClient } from '../../api/Extensions';

type SiteInfoProps = {
    site?: SiteDto;
};

export default function SiteInfo(props: SiteInfoProps): ReactElement {
    const { site } = props;

    const clients = useSelector((state: RootState) => state.clients.clients);

    const [project, setProject] = useState<ProjectDto | undefined>(undefined);
    const [client, setClient] = useState<ClientDto | undefined>(undefined);

    useEffect(() => {
        if (!!site && !!site.projectId && site.projectId > 0) {
            WarehouseClient.getProjectById(site.projectId, true, false, false).then((res) => {
                setProject(res);
                if (!!res.clientId && res.clientId > 0) {
                    const currClient = clients?.find((cl) => cl.id === res.clientId);

                    if (!!currClient) {
                        setClient(currClient);
                    } else {
                        WarehouseClient.getClientById(res.clientId, false).then((resCl) => {
                            setClient(resCl);
                        });
                    }
                }
            });
        }
    }, [site]);

    return (
        <Box sx={{ p: 0, pl: { xs: 1, sm: 3 }, pt: 2, pr: { xs: 0, sm: 2 }, m: 0, textAlign: 'start' }}>
            <Grid2 container spacing={0}>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body1">
                        Naziv skladišta: <span style={{ fontWeight: 'bold' }}>{site?.name}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body1">
                        Klijent: <span style={{ fontWeight: 'bold' }}>{client?.shortName ?? client?.name ?? '/'}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body1">
                        Tip skladišta:{' '}
                        <span style={{ fontWeight: 'bold' }}>{site?.siteType ? SiteTypeSR[site.siteType] : '/'}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body1">
                        Projekat: <span style={{ fontWeight: 'bold' }}>{project?.name ?? '/'}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12 }} sx={{ height: 15 }} />
                <Grid2 size={{ xs: 12 }}>
                    <Typography variant="body1">
                        Adresa:{' '}
                        <a
                            href={mapsSearchUrl(getAddressFromLoactionInfo(site?.locationInfo))}
                            target="_blank"
                            rel="noreferrer"
                            style={{ fontWeight: 'bold', color: 'inherit' }}
                        >
                            {getAddressFromLoactionInfo(site?.locationInfo)}
                        </a>
                    </Typography>
                </Grid2>
            </Grid2>
        </Box>
    );
}
